import type { SVGProps } from "react";

export const Copy = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="size-4"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.19 3.81c-.39-2.33-1.64-2.66-5.44-2.66-5 0-5.6.58-5.6 5.6 0 3.8.33 5.05 2.66 5.44.39 2.32 1.65 2.66 5.44 2.66 5 0 5.6-.58 5.6-5.6 0-3.79-.34-5.05-2.66-5.44ZM2.35 6.75c0-4.36 0-4.4 4.4-4.4s4.4 0 4.4 4.4 0 4.4-4.4 4.4-4.4-.04-4.4-4.4Zm6.9 6.9c-2.91 0-3.9 0-4.23-1.34h1.73c5 0 5.6-.58 5.6-5.6V4.98c1.32.33 1.34 1.32 1.34 4.23-.04 4.4-.08 4.44-4.44 4.44Z"
      />
    </svg>
  );
};
